const LABEL_KEYS: Record<string, string> = {
  knowledge_ids: "knowledge_ids",
  target_knowledge_id: "target_knowledge_id",
  folder_ids: "folder_ids",
  target_folder_id: "target_folder_id",
  tag_ids: "tag_ids",
  category_id: "category_id",
  category_ids: "category_ids",
  target_category_id: "target_category_id",
  media_asset_ids: "media_asset_ids",
  workflow_id: "workflow_id",
  workflowid: "workflow_id",
  connector_id: "connector",
  connectorid: "connector",
  tool_id: "tool_id",
  tools: "tools_allowed",
  entity_id: "entity_id",
  approvers: "approvers",
  model_id: "model_id",
  statuses: "statuses",
  publication: "publication",
  content_mode: "content_mode",
  include_metadata: "include_metadata",
  mode: "mode",
  title_template: "title_template",
  content_field: "content_field",
  provenance: "provenance",
  input_mapping: "input_mapping",
  wait_for_completion: "wait_for_completion",
  scope: "scope",
  depth: "depth",
  timeout: "timeout",
  max_rows: "max_rows",
  output_as: "output_as",
};

export function catalogFieldLabelKey(key: string) {
  return LABEL_KEYS[normalizeConfigKey(key)] ?? null;
}

function normalizeConfigKey(key: string) {
  return key.replace(/([a-z0-9])([A-Z])/g, "$1_$2").toLowerCase();
}
